<template>
    <div><!-- --></div>
</template>
<script>
    export default {
        name: "TicketStore",
        mounted() {
            this.ticketCheck();
        },
        methods: {
            async ticketCheck(){
                if (this.$route.params.ticket){
                    await this.$ticketService.store(this.$route.params.ticket);

                    //this.$sessionService.remove();

                    return this.$router.replace({ name: 'ticketSelect' });
                }
            },
        }
    }
</script>

<style scoped>
</style>
